import {addHandler, removeHandler} from './scroll_resize';

let initRegistry = [];
let handlers = {};
let disabledHandlers = {};

export default function register (selector, func) {
  /* Register an init function for elements matching the selector. */

  initRegistry.push([selector, func]);
}

function getInitFunction (el) {
  /* Get a matching init function for the element from the registry, based on
     the function's paired selector. */

  for (let i = 0; i < initRegistry.length; i++) {
    if (el.classList.contains(initRegistry[i][0])) {
      return initRegistry[i][1];
    }
  }
}

function makeGuid () {
  /* Note - not actually unique, but chance of a clash is tiny. */
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}

export function initContainers (containers) {
  /* Initialises the given containers by calling the {classname}Init function
     (where classname is the container's first css class, camelcased) if it
     exists. Init functions may return a "handler" object, which may have
     the following methods:

       resize: called on window resize, see events.js
       scroll: called on window scroll, see events.js
       teardown: called when the container is removed from the DOM

     If a handler is returned, it is saved as a data attribute on the
     container.
  */

  function doInit (els, initFunc) {
    const handler = initFunc(els);
    if (handler /* && (handler.resize || handler.scroll)*/) {
      addHandler(handler, true);
    }
    return handler;
  }

  containers.forEach((container) => {
    const init = getInitFunction(container);

    if (init && !container.getAttribute('data-initialised')) {
      const obj = doInit(container, init);
      container.setAttribute('data-initialised', true);

      let guid = container.getAttribute('data-guid');
      if (!guid) {
        guid = makeGuid();
        container.setAttribute('data-guid', guid);
      }
      handlers[guid] = obj;
    }
  });
}

export function teardownContainers (containers) {
  /* Called when the given containers are removed from the DOM. Removes
     scroll/resize handlers and calls the container's teardown if one exists.
  */

  containers.forEach((container) => {
    const guid = container.getAttribute('data-guid');
    const handler = handlers[guid];

    container.removeAttribute('data-guid');
    container.removeAttribute('data-initialised');

    if (handler) {
      removeHandler(handler);
      if (handler.teardown) handler.teardown();
      handlers[guid] = null;
    }
  });
}

export function disableContainers (containers) {
  /* Temporarily disable the handlers so they can be re-enabled,
     use case with overlay */
  containers.forEach((container) => {
    // shift current handlers to disabled.
    const guid = container.getAttribute('data-guid');
    disabledHandlers[guid] = handlers[guid];
  });
  teardownContainers(containers);
}

export function enableContainers (containers) {
  /* reenable a disabled handler
     use case with overlay */

  containers.forEach((container) => {
    // shift current disabled handlers back to handlers.
    const guid = container.getAttribute('data-guid');
    if (disabledHandlers[guid]) {
      handlers[guid] = disabledHandlers[guid];
      addHandler(handlers[guid], true);
    }
    disabledHandlers[guid] = null;
  });
}



// WEBPACK FOOTER //
// ./assets/j/util/init.js